export default __webpack_public_path__ + "static/springboot-ea8087060ad060fb0bd478900194d364.png";